import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import PATHS from './routesMap'

import Home from '../views/home/Home.vue'

const routes = [
  {
    name: 'Home',
    path: PATHS.HOME,
    component: Home,
  },
  {
    name: 'Register',
    path: PATHS.REGISTER,
    component: () =>
      import(
        /* webpackChunkName: "register" */ '../views/register/Register.vue'
      ),
  },
  {
    name: 'Form',
    path: PATHS.FORM,
    component: () =>
      import(/* webpackChunkName: "form" */ '../views/forms/Form.vue'),
  },
  {
    name: 'FormQuestion',
    path: PATHS.FORM_QUESTION,
    component: () =>
      import(/* webpackChunkName: "form" */ '../views/forms/FormQuestion.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'Results',
    path: PATHS.RESULTS,
    component: () =>
      import(/* webpackChunkName: "form" */ '../views/results/Results.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'Thanks',
    path: PATHS.THANKS,
    component: () =>
      import(/* webpackChunkName: "form" */ '../views/thanks/Thanks.vue'),
  },
  {
    name: 'Unauthorized',
    path: PATHS.UNAUTHORIZED,
    component: () =>
      import(
        /* webpackChunkName: "unauthorized" */ '../views/unauthorized/Unauthorized.vue'
      ),
  },
  {
    name: 'NotFound',
    path: '/:pathMatch(.*)*',
    component: () =>
      import(
        /* webpackChunkName: "notFound" */ '../views/notFound/NotFound.vue'
      ),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach(async (to, from) => {
  const { isLoggedUserInEthosNextGen } = store.getters

  if (to.meta.requiresAuth) {
    if (
      !isLoggedUserInEthosNextGen &&
      !localStorage.getItem('tokenUserEthosNextGen')
    ) {
      if (to.name !== 'Results' && to.params.code) {
        return { name: 'Register', params: { code: to.params.code } }
      }

      return { name: 'Home' }
    }
  }
})

export default router
